import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import UsersTable from "@/components/ListTable/UsersTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { USERS_INCLUDES } from "@/entities/users";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { ListProvider } from "@/modules/list";
import UserAddButton from "@/modules/user/user-add-button";

const Users = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("navigation:users")}
        extra={[<UserAddButton key="user-add-button" />]}
      />
      <AppLayoutPage>
        <ListProvider
          endpoint="users"
          storageKey={STORAGE_KEYS.USERS}
          includes={[USERS_INCLUDES.ORGANIZATION, USERS_INCLUDES.ROLES]}
        >
          <UsersTable />
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Users;
